module.exports = __webpack_public_path__ + "img/icon_st01.15992324.png";